import { Box, Text } from '@everlywell/ui-kit';
import React from 'react';

interface ErrorStateProps {
  message: string;
  minHeight?: string;
  pt?: string[] | string;
  mb?: string[] | string;
}

/**
 * A standardized error state component
 */
const ErrorState: React.FC<ErrorStateProps> = ({
  message,
  minHeight = '400px',
  pt = ['5rem', '6rem'],
  mb = '5rem',
}) => (
  <Box
    as="section"
    pt={pt}
    mb={mb}
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight={minHeight}
  >
    <Text color="red.500" fontSize="xl">
      {message}
    </Text>
  </Box>
);

export default ErrorState;
